import React from "react"
import Responsive from "react-responsive"

import TransactionsTrend from "./TransactionsTrend"

const Desktop = props => <Responsive {...props} minWidth={700} />
const Mobile = props => <Responsive {...props} minWidth={0} maxWidth={699} />

const Section3 = () => {
  return (
    <section className="section3">
      <h1 className="section3-banner">
        <span className="section3-paymentPartners">
          Our current payment partners
        </span>{" "}
        with much more on the horizon
      </h1>
      <Desktop>
        <img
          className="section3-paymentProviders"
          src="/images/Section3/payment-providers-desktop.svg"
          alt="Payment providers desktop"
        />
      </Desktop>
      <Mobile>
        <img
          className="section3-paymentProviders"
          src="/images/Section3/payment-providers-mobile.svg"
          alt="Payment providers mobile"
        />
      </Mobile>
      <TransactionsTrend />
    </section>
  )
}

export default Section3
